"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeResponse = exports.isResponseWithData = exports.getListResponseData = exports.aggregateResults = void 0;
var utils_1 = require("../utils");
function aggregateResults(results) {
    return {
        error: results.some(function (result) { return !!result.error; }),
        loading: results.some(function (result) { return result.loading; }),
    };
}
exports.aggregateResults = aggregateResults;
/**
 * New list APIs have started putting the paginated data into an "items" property in the response data.
 * @param response The listing response
 */
function getListResponseData(response) {
    if (!response || !response.data) {
        return [];
    }
    if (Array.isArray(response.data)) {
        return response.data;
    }
    return response.data.items;
}
exports.getListResponseData = getListResponseData;
/**
 * Checks if the response has a body, or is just headers such as in a work request
 */
function isResponseWithData(response) {
    var maybeResponseWithData = response;
    return (maybeResponseWithData.data !== undefined &&
        maybeResponseWithData.response !== undefined);
}
exports.isResponseWithData = isResponseWithData;
/**
 * parses response headers and passes along other serializable data for redux storage
 */
function serializeResponse(response) {
    if (isResponseWithData(response)) {
        var _a = response.response, status_1 = _a.status, statusText = _a.statusText, ok = _a.ok;
        var result_1 = {
            data: response.data,
            response: {
                status: status_1,
                statusText: statusText,
                ok: ok,
                headers: utils_1.parseResponseHeaders(response.response),
            },
        };
        return result_1;
    }
    var result = {
        status: response.status,
        statusText: response.statusText,
        ok: response.ok,
        headers: utils_1.parseResponseHeaders(response),
    };
    return result;
}
exports.serializeResponse = serializeResponse;
//# sourceMappingURL=response.js.map